import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { TestQuestion } from "@/modules/theme/components/TestQuestion/TestQuestion";

import { TestQuestionType } from "../TutorialDetailsPage/hooks/parseTutorialProgress";

import { TutorialTestStructType } from "./TutorialTestPage";

const answersFieldName = "answers" as const;

type QuestionsProps = {
  questions: TestQuestionType[];
};

const translationNamespace = "pages/TutorialTestPage";

export const Questions: React.FC<QuestionsProps> = ({ questions }) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<TutorialTestStructType>();
  const { fields } = useFieldArray<TutorialTestStructType>({
    control,
    name: answersFieldName,
  });

  const { t } = useTranslation(translationNamespace);

  return (
    <div>
      {fields.map((item, index) => {
        const currentQuestion = questions.find(
          (question) => question.id === item.questionId
        );
        const inputError = errors.answers?.[index]?.answerIndex?.type;

        return (
          <div key={item.questionId}>
            <input
              type="hidden"
              {...register(`${answersFieldName}.${index}.questionId`)}
            />
            {currentQuestion && (
              <TestQuestion
                error={inputError}
                key={currentQuestion.id}
                answers={currentQuestion.answers.map((answer, index) => ({
                  id: `${currentQuestion.id}-${index}`,
                  label: answer,
                  value: index.toString(),
                }))}
                question={currentQuestion.content}
                {...register(`${answersFieldName}.${index}.answerIndex`)}
                errorMessages={{
                  "string.notEmpty": t("The answer is required"),
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
